/**
 * @generated SignedSource<<e5a5c66db7137f2d943eb9ae61c84420>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavDropdownItem_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountManagerComponent_seller" | "VatReportModal_seller">;
  readonly " $fragmentType": "NavDropdownItem_seller";
};
export type NavDropdownItem_seller$key = {
  readonly " $data"?: NavDropdownItem_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavDropdownItem_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavDropdownItem_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountManagerComponent_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VatReportModal_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "7de95d2d94a5067223b58c7f727ed3fb";

export default node;
